import { render, staticRenderFns } from "./SliderMenuIcon.vue?vue&type=template&id=ec121254"
import script from "./SliderMenuIcon.vue?vue&type=script&lang=js"
export * from "./SliderMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports